import apiService from "@/api/ApiService";

const NOTIFICATION_URL = "/notifications/";
const NOTIFICATIONS_READ_URL = "/notifications/bulk_read/";
const NOTIFICATION_PREFERENCES = "/new-notification-preferences/";

export class NotificationService {
  async getNotificationPreferences() {
    return (await apiService.get(NOTIFICATION_PREFERENCES)).data;
  }

  async updateNotificationPreferences(payload) {
    return await apiService.post(NOTIFICATION_PREFERENCES, payload);
  }

  async getNotifications(params) {
    return (await apiService.get(NOTIFICATION_URL, { params: params })).data;
  }

  async updateNotification(params) {
    return (
      await apiService.patch(NOTIFICATION_URL + params.id + "/", {
        status: params.status
      })
    ).data;
  }

  async readAllNotification(params) {
    return (
      await apiService.put(NOTIFICATIONS_READ_URL, {
        status: params.status
      })
    ).data;
  }
}

const notificationService = new NotificationService();

export default notificationService;
